@if (rejectedFiles != null) {
  @if (multiple) {
    <ul class="rejected-files">
      @for (rejectedFile of rejectedFiles.files; track rejectedFile) {
        <li class="rejected-file">
          <span
            [innerHTML]="
              i18nPrefix + rejectedFile.reason + '.html' | translate: translateContext(rejectedFile)
            "
          ></span>
          @if (clearable) {
            <portal-icon-button
              (onClick)="clear.emit(rejectedFile)"
              iconClass="far fa-times"
            ></portal-icon-button>
          }
        </li>
      }
    </ul>
  }
  @if (multiple === false) {
    <div class="rejected-file">
      <span
        [innerHTML]="
          i18nPrefix + rejectedFiles.files[0].reason + '.html'
            | translate: translateContext(rejectedFiles.files[0])
        "
      ></span>
      @if (clearable) {
        <portal-icon-button
          (onClick)="clear.emit(rejectedFiles.files[0])"
          iconClass="far fa-times"
        ></portal-icon-button>
      }
    </div>
  }
}
